module.exports = __webpack_public_path__ + "img/RO.ce48887a.svg";